import { useFormik } from 'formik';
import { useEffect } from 'react';
import { ISelect } from '../../../../../../shared/types/shared';
import { InitialCausality } from '../../../../../../shared/types/typifications/initialCausality';
import { initialValues } from './formData';

export const useInitialCausalityData = (
    initialCausality?: InitialCausality
) => {
    const formik = useFormik({
        initialValues: {
            ...initialValues,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            ...initialCausality,
            product:
                (initialCausality?.product as ISelect)?.name.toString() || '',
            motive:
                (initialCausality?.motive as ISelect)?.name.toString() || '',
            typePqr:
                (initialCausality?.typePqr as ISelect)?.name.toString() || '',
            submotive1:
                (initialCausality?.submotive1 as ISelect)?.name.toString() ||
                '',
            submotive2:
                (initialCausality?.submotive2 as ISelect)?.name.toString() ||
                '',
            submotive3:
                (initialCausality?.submotive3 as ISelect)?.name.toString() ||
                '',
            submotive4:
                (initialCausality?.submotive4 as ISelect)?.name.toString() ||
                '',
            typeComplaint:
                (initialCausality?.typeComplaint as ISelect)?.name.toString() ||
                '',
            technicalBranch:
                (
                    initialCausality?.product?.technicalBranch as ISelect
                )?.name.toString() || '',
            unifiedProduct:
                (
                    initialCausality?.product?.unifiedProduct as ISelect
                )?.name.toString() || '',
            typeMotive:
                (initialCausality?.typeMotive as ISelect)?.name.toString() ||
                '',
        });
    }, [initialCausality]);

    return {
        formik,
    };
};
